
import {
  ClassNameMap
} from '@mui/styles';
import Box from '@mui/material/Box';

import ListItemText from '@mui/material/ListItemText';
import ClearIcon from '@mui/icons-material/Clear';
import * as request from 'superagent';
import {Badge, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList, Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import NotificationsIcon from '@mui/icons-material/Notifications';
import classNames from 'classnames';

import React, { useRef, useLayoutEffect, useState } from "react";

function fetchAlerts(props: any, query: string, probe: boolean) {
  var url = "/api/alerts/list"
    return new Promise(function (resolve, reject) {
      request
        .get(url)
        .set('accept', 'application/json')
        .send()
        .then((response) => {
          
          if (response.statusCode == 200) {
            if (response.body) {
              resolve(response.body);
            } else {
              resolve([])
            }
          } else {
            reject(response.body);
          }
        })
        .catch((err: any) => {
          reject(err);
        });
    });
};

function unwrapAlerts(alerts): {unwrapped: any; count: number} {
  var unwrapped = [];
  var newCount = 0
  if (alerts) {
    alerts.forEach((a: any) => {
      if (a.unviewedCount > 0) {
        newCount ++
      }
      unwrapped.push(a);
    })
  }
    return {unwrapped: unwrapped, count: newCount};

};

export default function AlertButton(props) {
  const { classes }: { classes: ClassNameMap } = props;
  const [alertsOpen, setAlertsOpen] = useState(false);
  const [alertCount, setAlertCount] = useState(0);
  const [show, setShow] = React.useState(false)
  const [alertItems, setAlertItems] = useState([]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    
  // };
  
  // const theme = use(theme);

  const probeAlerts = async value => {
    // UPGRADE: JD bypassing this until we can figure out how to make sure that it does not get called if alerts are not supported.
    // console.log("bypassing probeAlerts until we can figure out how to make sure that it does not get called if alerts are not supported.")
    var showAlerts = false
    if ((window as any).App && (window as any).App.browserEnvironment) {
      showAlerts = (window as any).App.browserEnvironment.BROWSER_ENABLE_ALERT_MODULE
    }
    if(showAlerts){
      var response:any = await fetchAlerts(props, value, true)
      var itemsObj = unwrapAlerts(response.items)
      setAlertCount(itemsObj.count)
      setAlertItems(itemsObj.unwrapped)
    }
  }

  const onToggleAlertMenu  = (event: React.MouseEvent<HTMLElement>) => {
    var runView = false
    if (!alertsOpen) {
      runView = true
    }
    if (alertItems.length > 0) {
      setShow(false)
      setAlertsOpen(!alertsOpen)
      setAnchorEl(anchorEl ? null : event.currentTarget);
      setAlertCount(0)


      if (runView) {
        return new Promise(function (resolve, reject) {
          request.post("/api/alerts/view")
          .set('accept', 'application/json')
          .send()
          .then((response) => {
            if (response.statusCode == 200) {
              if (response.body) {
                resolve(response.body);
              } else {
                resolve([])
              }
            } else {
              reject(response.body);
            }
          })
          .catch((err: any) => {
            reject(err);
          });
        });
      }
    }
  };

  const clearAlerts  = (alert) => {
    setAlertsOpen(false)
    setAnchorEl(null)
    return new Promise(function (resolve, reject) {
      request.post("/api/alerts/clear/all")
      .set('accept', 'application/json')
      .send()
      .then((response) => {
        if (response.statusCode == 200) {
          if (response.body) {
            resolve(response.body);
            setAlertCount(0)
            setAlertItems([])
          } else {
            resolve([])
            setAlertCount(0)
            setAlertItems([])
          }
        } else {
          reject(response.body);
        }
      })
      .catch((err: any) => {
        reject(err);
      });
    });
  };

  const onClickAway  = () => {
    setAlertsOpen(false)
    setAnchorEl(null)
  };

  const onAlertItemClick  = (item) => () => {
    var alertType = ""
    if (item && item.alertType){
      alertType = item.alertType
    }
    if (item && item.extendedAttributes && item.extendedAttributes.url) {
      
      request.post("/api/alerts/clear/type")
      .send({alertType:alertType})
      .responseType("blob")
      .set("Content-Type", "application/json").then((response)=>{
          if (response.ok) {
             
          } else {
      
          }
      }).catch((err)=>{

      })

      window.location.href = item.extendedAttributes.url;
    };
    
  };

  React.useEffect(probeAlerts, [])
  



  return (
    <Tooltip enterDelay={500} title="Alerts"
    onMouseEnter={() => {
      if (!alertsOpen){
      setShow(true)}}}
    onMouseLeave={() => setShow(false)}
    open={show}
    >
    <IconButton
        size="medium"
        onClick={onToggleAlertMenu}
        color="primary"
        className={classNames(classes.alertButton, classes.menuButton)}
        >
          <Badge badgeContent={alertCount} overlap="circular" anchorOrigin={{vertical: 'bottom',horizontal: 'right',}} color="secondary">
            <NotificationsIcon fontSize="large" color="icon"/>
            <Popper open={alertsOpen}  placement={'bottom-end'} role={undefined} anchorEl={anchorEl}  transition disablePortal>
              {({ TransitionProps, placement }) => (
                  <Grow
                  exit={false}
                  {...TransitionProps}
                  style={{
                      transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                  >
                  <Paper elevation={3}>
                  <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    height: '15px'
                  }}
                >
      
                    <IconButton
                          size="small"
                          onClick={clearAlerts}
                          color="primary"
                          // sx={clearStyle}
                          >
                            <ClearIcon fontSize="small" sx={{height: '14px', width: '14px'}}/>
                        </IconButton>
                        </Box>
                      <ClickAwayListener onClickAway={onClickAway}>

                      <MenuList id="split-button-menu" 
                      sx={{pt: 0, mt:0}}
                      // className={classes.complexButtonMenuList}
                      >
                          {alertItems.map((item, index) =>  (                           
                              <MenuItem

                                  key={item.alertType}
                                  onClick={onAlertItemClick(item)}
                              >
                                <ListItemText>{item.templateContents}</ListItemText>
                                  
                              </MenuItem>
                              )

                          )}
                      </MenuList>
                      </ClickAwayListener>
                  </Paper>
                  </Grow>
              )}
              </Popper>
          </Badge>
      </IconButton>
      </Tooltip>
  );
};